import { render } from "./ParamTransportChargeUnitPageList.vue?vue&type=template&id=f218fc9a&scoped=true&ts=true"
import script from "./ParamTransportChargeUnitPageList.vue?vue&type=script&lang=ts"
export * from "./ParamTransportChargeUnitPageList.vue?vue&type=script&lang=ts"

import "./ParamTransportChargeUnitPageList.vue?vue&type=style&index=0&id=f218fc9a&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f218fc9a"]])

export default __exports__